<template>
  <div class="seg-content general user">
        <form class="user-form login" v-on:submit.prevent="saveProfile">
          <div class="uf-row split">
            <div>
              <label>Username</label>
              <input type="text" readonly v-model="userProfile.username" placeholder="Username" />
            </div>
            <div>
              <label>Email Address</label>
              <input type="email" v-model="userProfile.email" placeholder="Email Address" />
            </div>
          </div>
          <div class="uf-row split">
            <div>
              <label>First Name</label>
              <input type="text" v-model="userProfile.firstname" placeholder="First Name" />
            </div>
            <div>
              <label>Last Name</label>
              <input type="text" v-model="userProfile.lastname" placeholder="Last Name" />
            </div>
          </div>
          <div class="uf-row split">
            <div>
              <label>Password</label>
              <input type="password" v-model="userProfile.newPassword" placeholder="Password" />
            </div>
            <div>
              <label>Confirm Password</label>
              <input type="password" v-model="userProfile.confirmPassword" placeholder="Confirm Password" />
            </div>
          </div>
          <!--<div class="uf-row split">
            <div>
              <label style="display: block; text-align: right">Default currency:</label>
            </div>
            <div class="currency-select">
              <label class="radio" :class="{checked: userProfile.currency=='USD'}">
                <input type="radio" v-model="userProfile.currency" value="USD" /><i></i>
                $
              </label>
              <label class="radio" :class="{checked: userProfile.currency=='EUR'}">
                <input type="radio" v-model="userProfile.currency" value="EUR" /><i></i>
                €
              </label>
              <label class="radio" :class="{checked: userProfile.currency=='CHF'}">
                <input type="radio" v-model="userProfile.currency" value="CHF" /><i></i>
                CHF
              </label>
              
            </div>
          </div>-->
          <div class="uf-row to-c">
            <button class="main">Update</button>
          </div>
        </form>

    
  </div>
</template>
<script>
import api from './api';
import moment from 'moment';
export default {
  data: ()=>({
    package: null,
    paymentReady: null,
    detailsSaved: false,
    success: false,
    freq: null,
    years: null,
    gender: null,
    userProfile: {
      emailprefs: {},
    },
  }),
  watch: {
  },
  methods: {
    formatDate(date, format) {
      if (!date)
        return "";
      return moment(date).format(format);
    },

    async loadUserData() {
      if (!window.appRoot.loggedIn)
        return this.$router.replace({name: "user.login"});
      this.userProfile=(await api.get("User", window.appRoot.loggedIn.id)).item || this.userProfile;
      this.userProfile.emailprefs=this.userProfile.emailprefs || {};
    },
    reloadUserProfile() {
      this.loadUserData();
    },
    async saveProfile() {
      var profile=JSON.parse(JSON.stringify(this.userProfile));
      delete profile.password;
      profile.media=profile.media && profile.media.id;
      await api.update("User", this.userProfile.id, profile);
      appRoot.loggedIn.currency=profile.currency;
      
      appNotifications.show("Profile updated", "success");
      if (profile.newPassword) {
       // this.actionLogout();
      }
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
  },
  created() {
    this.loadUserData();
  },
  destroyed() {
  },
}
</script>
